import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderPriceCss from '../../assets/header/header-price.module.scss';

const HeaderPrice: FC = () => {
  const {
    advert: {
      price,
    },
  } = useAdvertDetailContext();

  if (!price) {
    return null;
  }

  return (
    <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice}>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__value}>
        {price}
      </div>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__label}>
        <FormattedMessage defaultMessage="hour rate" />
      </div>
    </div>
  );
};

export { HeaderPrice };
